import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, Plus, Package } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import PageHero from "@/components/PageHero";

export default function LostFound() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/qr").then(({ data }) => setItems(data.filter((x) => x.type === "lostfound" || x.type === "luggage")));
  }, []);

  return (
    <div className="max-w-6xl">
      <PageHero
        kicker="Lost & found"
        title="Recover what matters"
        subtitle="Attach a QR to keys, wallet, luggage, backpack — instant contact when scanned."
        image="https://images.unsplash.com/photo-1604357209793-fca5dca89f97?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80"
        accent="accent"
        testId="lostfound-hero"
      />
      <div className="flex justify-end mb-6 flex-wrap gap-4">
        <Button asChild className="bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90 text-white rounded-full" data-testid="add-lostfound-btn">
          <Link to="/app/qr"><Plus className="w-4 h-4 mr-2" /> New tag</Link>
        </Button>
      </div>

      {items.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-border p-16 text-center">
          <Search className="w-10 h-10 mx-auto text-muted-foreground mb-3" />
          <div className="font-medium mb-1">No tags yet</div>
          <div className="text-sm text-muted-foreground mb-4">Create your first Lost & Found tag.</div>
          <Button asChild><Link to="/app/qr">Create tag</Link></Button>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((it) => (
            <div key={it.id} className="rounded-2xl border border-border/70 bg-card p-5" data-testid={`lostfound-${it.id}`}>
              <div className="flex items-start justify-between mb-3">
                <div className="w-10 h-10 rounded-xl bg-[hsl(var(--accent))]/10 grid place-items-center">
                  <Package className="w-5 h-5 text-[hsl(var(--accent))]" />
                </div>
                <Badge variant="outline" className="uppercase text-[10px] tracking-wider">{it.type}</Badge>
              </div>
              <div className="font-display font-bold text-lg tracking-tight">{it.display_name}</div>
              <div className="text-sm text-muted-foreground mb-3 line-clamp-2">{it.item_description || "—"}</div>
              <div className="text-xs text-muted-foreground border-t border-border/50 pt-3 flex items-center justify-between">
                <span>{it.reward ? `Reward: ${it.reward}` : "No reward set"}</span>
                <span>{it.scan_count} scans</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
